module.exports = __webpack_public_path__ + "img/bear_small.7dd836ec.png";